/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { EventService } from '@shared/services/event.service';
import { MatchService } from 'src/app/services/match.service';
import { AppStateService } from '@shared/services/app-state.service';

@Component({
  selector: 'app-tabs',
  templateUrl: 'tabs.page.html',
  styleUrls: ['tabs.page.scss']
})
export class TabsPage {
  public newCount: number = 0;
  public superLikeCount: number = 0;
  public flag: string = 'home';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private eventSubscription: Subscription|any;

  constructor( public matchService: MatchService,
    private eventService: EventService,
    private appStateService: AppStateService
  ) {
    matchService.getUpdates().subscribe((data) =>{
      console.log('matchService subscribe called: ' + data);
      if(data == -1){
        if(this.newCount > 0){
          this.newCount--;
        } else{
          this.newCount = 0;
        }
      }else{
        this.newCount = data;
      }
    });

    this.appStateService.superLikeSubject.subscribe((data) => {
      console.log('superLikeSubject subscribe called: ' + data);
      if(data == -1){
        if(this.superLikeCount > 0){
          this.superLikeCount--;
        } else{
          this.superLikeCount = 0;
        }
      }else if (data == null){
        this.superLikeCount++;
      }else{
        this.superLikeCount = data;
      }
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  change(event:any){
    this.flag = event.detail.tab;
  }

  ngOnInit(){
    this.eventSubscription = this.eventService.getEvent('updateNewCount').subscribe(data => {
      console.log('Event received:', data);
      if (this.newCount>0){
        this.newCount--;
      }
    });
  }
  ngOnDestroy() {
    if (this.eventSubscription) {
      this.eventSubscription.unsubscribe();
    }
  }
}
